import {useEffect, useRef, useState} from 'react';
import useOutsideClick from './mouse/useOutsideClick';

export const useCreateTagModal = (id: string) => {
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
	const createModalRef = useRef<HTMLDivElement>(null);

	const openModal = () => {
		setIsCreateModalOpen(true);
	}
	const closeModal = () => {
		setIsCreateModalOpen(false);
	}

	const handleCreateTagAction = (e: React.MouseEvent | React.KeyboardEvent) => {
		if (e.type === 'keydown') {
			const keyboardEvent = e as React.KeyboardEvent;
			if (keyboardEvent.key !== 'Enter' && keyboardEvent.key !== ' ') return;
		}

		// e.stopPropagation();
		openModal();
	};

	const handleModalClick = (e: React.MouseEvent) => {
		e.stopPropagation();
	};

	useOutsideClick(createModalRef, closeModal, isCreateModalOpen, id);

	return {
		isCreateModalOpen,
		createModalRef,
		closeModal,
		handleCreateTagAction,
		handleModalClick,
	};
};
